// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"_2ijy4","share-button":"_5DS8B","messenger":"_39GWW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/MessengerShareButton.scss
// module id = ./src/components/ShareModal/MessengerShareButton.scss
// module chunks = 5